<template>

    <header>
        <div class="row-black no-padding-bottom clearfix">
            <div class="content-960">

                <div class="menu pull-left bt-mobile">
                    <div class="dropdown menu-mobile">
                        <b-dropdown class="text-white" variant="link" no-caret>
                            <b-dropdown-item v-canaccess="'/home'">
                                <router-link to="/home">Home</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/iniciarprocessoseletivo'">
                                <router-link to="/iniciarprocessoseletivo">Iniciar Processo Seletivo</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/colaborador'">
                                <router-link to="/colaborador">Colaboradores / Candidatos</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/candidato'">
                                <router-link to="/candidato">Testes / Entrevistas</router-link>
                            </b-dropdown-item>

                            <b-dropdown-divider></b-dropdown-divider>

                            <b-dropdown-item v-canaccess="'/questao'">
                                <router-link to="/questao">Questões</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/avaliacao'">
                                <router-link to="/avaliacao">Testes</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/tagjobs'">
                                <router-link to="/tagjobs">Tags</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxconceito'">
                                <router-link to="/auxconceito">Conceitos</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxdisciplina'">
                                <router-link to="/auxdisciplina">Disciplina</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxdificuldade'">
                                <router-link to="/auxdificuldade">Dificuldade</router-link>
                            </b-dropdown-item>

                        </b-dropdown>
                    </div>
                </div>

                <a href="/home" title="Logo CNA Portal Corporativo" class="logo-header">
                    <img src="../assets/imagens/logos/logo-CNA-big.png" alt="Imagem Logo CNA" title="CNA Jobs" class="logo-desktop" />
                    <img src="../assets/imagens/logos/logo-CNA-mobile.png" alt="Imagem Logo CNA" title="CNA Jobs" class="logo-mobile margin-ajust" />
                </a>

                <div class="user">
                    <div class="click-menu click-animate">
                        <div class="img-user">
                            <img :src="urlFoto" alt="Imagem do Usuário" :title="user.name" />
                        </div>
                        <h2>Olá, <span :title="user.name">{{user.name}}</span></h2>
                        <div class="cna-local">
                            <span :title="escolaNome">{{escolaNome}}</span>

                            <a class="icons-arrows" href="javascript:void(0);" @click="irParaPortalCorporativo()">
                                <span><br />Ir para Portal Corporativo</span>
                            </a>

                            <router-link to="/trocarescola" class="icons-arrows">
                                <span><br />Trocar escola</span>
                            </router-link>

                            <a class="float-right" style="cursor: pointer;" @click="logout()">
                                Sair
                            </a>

                        </div><br />
                    </div>
                    <div class="wrap-conteudo">
                        <div class="dados-user-mobile">
                            <h2>Olá, <span>{{user.name}}</span></h2>
                            <div class="cna-local">
                                {{escolaNome}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-desktop">
                    <ul class="style-hover">

                        <li v-canaccess="'/home'">
                            <router-link to="/home">Home</router-link>
                        </li>

                        <li id="div-iniciarprocessoseletivo" v-canaccess="'/iniciarprocessoseletivo'">
                            <router-link to="/iniciarprocessoseletivo">Iniciar Processo Seletivo</router-link>
                        </li>
                        <li id="div-colaborador" v-canaccess="'/colaborador'">
                            <router-link to="/colaborador">Colaboradores / Candidatos</router-link>
                        </li>
                        <li id="div-candidato" v-canaccess="'/candidato'">
                            <router-link to="/candidato">Testes / Entrevistas</router-link>
                        </li>

                        <b-nav-item-dropdown v-canaccess="'/gerencial'" class="menu-color" text="Gerencial" left>

                            <b-dropdown-item v-canaccess="'/questao'">
                                <router-link to="/questao">Questões</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/avaliacao'">
                                <router-link to="/avaliacao">Testes</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/tagjobs'">
                                <router-link to="/tagjobs">Tags</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxconceito'">
                                <router-link to="/auxconceito">Conceitos</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxdisciplina'">
                                <router-link to="/auxdisciplina">Disciplina</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxdificuldade'">
                                <router-link to="/auxdificuldade">Dificuldade</router-link>
                            </b-dropdown-item>

                        </b-nav-item-dropdown>

                    </ul>
                </div>
            </div>
        </div>
    </header>

</template>
<script>

    import Global from '@/common/global'
    import Auth from '@/common/auth'

    export default {
        name: "header-cna",
        data() {
            return {
                urlPortalCorporativo: Global.URL_PORTAL_CORPORATIVO,
                user: { escolas: [] },
                foto: '',
            }
        },
        computed: {
            urlFoto() {
                return Global.URL_DOWNLOAD + "colaborador-foto/" + this.foto + "?v=" + Math.random();
            },
            escolaNome() {
                var escola = this.user.escolas.filter(_ => _.escolaId == +this.user.tenant)[0];
                if (escola) return escola.nomeEscola
                return "--";
            }
        },
        methods: {
            irParaPortalCorporativo: function () {
                sessionStorage.clear();
                window.location = this.urlPortalCorporativo;
            },
            logout: function () {
                Auth.logout()
            },
        },
        mounted() {
            this.user = Auth.currentUser();
            this.foto = Auth.getFotoUser();
        },

    };
</script>